/**
 * Canonical categorical palette for telling zones apart at a glance, shared by
 * the draw-tool zone editor (`draw-tool-state`) and the read-only plan-asset
 * render/inspector (`plan-asset-colors`) so the two don't carry separate
 * hardcoded color lists. Not designed legend colors — per-rate coloring is a
 * later refinement.
 */
export const ZONE_PALETTE = [
  '#4D96FF', // blue
  '#FF9F1C', // deep orange
  '#F15BB5', // pink
  '#8338EC', // purple
  '#E63946', // red
  '#06D6A0', // green-teal
  '#FFD93D', // yellow
  '#BA68C8', // dark violet
  '#00B4D8', // aqua / turquoise
  '#9EF01A', // lime green
  '#FF6D00', // orange-red
  '#C77DFF', // soft magenta
  '#118AB2' // cyan-blue / teal
]
